/* eslint-disable linebreak-style */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import dynamic from 'next/dynamic';
import { useAmp } from 'next/amp';
import Row from 'base-ui/dist/Row';
import Col from 'base-ui/dist/Col';
import Box from 'base-ui/dist/Box';
import Image from 'components/Image';
import { intl } from 'components/LocaleProvider';
import messages from './messages';

const AuthorSocialProfiles = dynamic(() => import('components/AuthorSocialProfiles'));
const RenderHtmlReact = dynamic(() => import('utils/RenderHtmlReact'));

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const AuthorBox = ({ author }) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(author.description.length < 100);
  }, [author]);

  if (author && author.description) {
    return (
      <div id="postAuthorBox" className={`post-author-box card gray-border${expanded ? ' open' : ''}`}>
        <Row>
          <Col xs="12" sm="12" id="moreTextContent" className={`summary${expanded ? '' : ' covered'}`}>
            <div className="author-avatar-box">
              <div className="author-avatar">
                <Image src={author?.picture} alt={author.name} lazy />
              </div>
              {author.social_profiles && (
                <Box className="social-media-icons align-right">
                  <AuthorSocialProfiles social_profiles={author.social_profiles} />
                </Box>
              )}
            </div>
            <NavLink
              basePath={publicRuntimeConfig.PUBLIC_URL}
              as={`${author?.permalink}`}
              to={`/author?slug=${author.slug}`}
              className="highlight font-medium titles-color full"
              routerStrategy={'next'}
            >
              {author.name}
            </NavLink>
            <div id="boxTxtAbout" className={`box-txt-about margin-top-medium${expanded ? ' open' : ''}`}>
              <p>
                <RenderHtmlReact
                  text={author.description}
                  withoutElement={['a']}
                />
              </p>
            </div>
          </Col>

          { // TODO: Remove it when add Consultation Buttons
            /* language=CSS */}
          <style jsx>
            {`#moreTextContent {
                overflow: hidden;
              }
              .box-txt-about {
                clear: none;
                overflow: unset;
              }
              #boxTxtAbout.open {
                margin-bottom: 3.5rem;
              }
            `}
          </style>
        </Row>

        <div className="more-link-button" style={{ display: expanded ? 'none' : 'block' }}>
          {useAmp() ? (
            <button
              type="button"
              id="moreLinkButton"
              data-with-google-events="true"
              data-google-events={JSON.stringify({
                data: {
                  action: 'click',
                  category: 'Read more',
                  label: `${author.name}`
                }
              })}
              on="tap:moreLinkButton.toggleClass(class='hidden'),moreTextContent.toggleClass(class='covered'),boxTxtAbout.toggleClass(class='open'),postAuthorBox.toggleClass(class='open')"
              className="btn white-bg regent-grey-border"
            >
              {intl.formatMessage(messages.readMore)}
            </button>
          ) : (
            <button
              type="button"
              id="moreLinkButton"
              data-with-google-events="true"
              data-google-events={JSON.stringify({
                data: {
                  action: 'click',
                  category: 'Read more',
                  label: `${author.name}`
                }
              })}
              className="btn white-bg regent-grey-border"
              onClick={() => setExpanded(true)}
            >
              {intl.formatMessage(messages.readMore)}
            </button>
          )}
        </div>
      </div>
    );
  }

  return null;
};

AuthorBox.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    permalink: PropTypes.string,
    description: PropTypes.string,
    profession: PropTypes.string,
    picture: PropTypes.string,
    address: PropTypes.string,
    social_profiles: PropTypes.object,
  }),
};

export default AuthorBox;
